export default __webpack_public_path__ + "media/images/texture-b718c405593a8bcbbcd7e819e72106be.jpg";